// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .v-application--wrap {\n  min-height: 1vh;\n}\n.subresources-data-table-wrapper .briq-data-table,\n.subresources-data-table-wrapper .briq-data-table th {\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
